export const PENDING_REQUEST_MSG = 'APPOINTMENT REQUEST PENDING';
